// AUTO-GENERATED by scripts/gen-version.js
export const SDK_VERSION = "0.21.0";
